<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { HTMLInputAttributes } from "svelte/elements";
  import { formatDynamicUSPhoneNumber } from "@/lib/helpers/phone";
  import TextInput from "../text-input/text-input.svelte";

  // https://github.com/sveltejs/eslint-plugin-svelte/issues/348
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface $$Props extends HTMLInputAttributes {
    label?: string;
    hint?: string;
    error?: string;
    value?: string;
    withLetters?: boolean;
    hideAreaCode?: boolean;
  }

  export let value = "";
  export let hideAreaCode = false;
  export let withLetters = false;

  const dispatch = createEventDispatcher<{
    value: { value: string };
  }>();

  let formatted = formatDynamicUSPhoneNumber(value, hideAreaCode);

  function onInput(event: Event) {
    const target = event.currentTarget as HTMLInputElement;
    const regex = withLetters ? /[^A-Za-z0-9]/g : /[^0-9]/g;

    const maxLength = hideAreaCode ? 7 : 10;
    value = target.value.replace(regex, "").slice(0, maxLength);

    value = value.toUpperCase();

    formatted = withLetters
      ? value
      : formatDynamicUSPhoneNumber(value, hideAreaCode);

    dispatch("value", { value });
  }
</script>

<TextInput
  {...$$restProps}
  bind:value={formatted}
  on:input={onInput}
  on:focus
  on:blur
/>
